'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timezoneAlreadySetup = false;

function setupTimezone(timezone) {
  if (_I18n2.default.manualTimezone) {
    return;
  }
  if (timezoneAlreadySetup === true) {
    return;
  }

  var timezoneId = timezone.id;

  try {
    if (timezone['moment-data']) {
      timezoneAlreadySetup = true;
      if (!_I18n2.default.moment.tz.zone(timezoneId)) {
        _I18n2.default.moment.tz.add(timezoneId + '|' + timezone['moment-data']);
      }
      return _I18n2.default.changeTimezone(timezoneId);
    } else {
      return Raven && Raven.captureMessage('I18n failed to parse api-verify data: ' + JSON.stringify(portal && portal.timezone));
    }
  } catch (e) {
    console.error('Unable to set up timezone', e);
    return Raven && Raven.captureException(e);
  }
};

function loadI18n(_ref) {
  var langEnabled = _ref.langEnabled,
      locale = _ref.locale,
      timezone = _ref.timezone;

  _I18n2.default.debugLog('Carmen response: locale = ' + locale + '  timezone = ' + timezone + '  langEnabled = ' + langEnabled);

  var validLocale = locale || _I18n2.default.locale;

  if (timezone && timezone.id) {
    setupTimezone(timezone);
  }

  _I18n2.default.langEnabled = langEnabled;
  _I18n2.default.debugLog('Lang enabled: ' + langEnabled);

  // Used in I18n.loadLocale
  _I18n2.default.loadedProjects = function () {
    return Object.keys(_I18n2.default.translationsLoaded);
  };

  _I18n2.default.debugLog(validLocale + ' is available locale, changing...');
  return Promise.resolve(_I18n2.default.changeLocale(validLocale)).then(function () {
    _I18n2.default.fired.ready = true;
  });
}

exports.default = loadI18n;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.233/js/load.js
// module id = 98
// module chunks = 0 1